export default {
  $vuetify: {
    noDataText: '抱歉没有找到此国家',

    common: {
      giftcard: '购买礼品卡',
      coupons: '购买优惠券',
      deposit: '充值',
      close: '关闭',
      cancel: '取消',
      back: '返回',
      continue: '继续',
      confirm: '确认',
      home: '主页',
      details: '详细信息',
      quantity: '数量',
      other: '其他',
      purchased: '购买成功',
      expires: '有效期至',
      includingTax: '含税',
      logout: '注销',
      orMore: '或更多',
      submit: '提交',
      tryAgain: '重试',
      success: '成功',
      info: '信息',
      edit: '编辑',
      hours: '小时',
      closed: '已关闭',
      location: '位置',
      contact: '联系方式',
      custom: '自定义',
    },

    account: {
      cancel: '取消',
      creditCard: '信用卡',
      nameOnCard: '姓名（请使用英文字母）',
      cardNumber: '卡号',
      expires: '有效日期',
      cvc: 'CVC',
      mmyy: '月/年',
      country: '信用卡所属国家',
      saveCard: '保存信用卡',
      addPaymentMethod: '添加信用卡',
      otherPostalCode: '非美国或加拿大卡，请任意输入',
    },

    featureSelect: {
      title: '选择两个功能之一'
    },

    checkout: {
      title: '付款信息',
      pay: '支付',
      confirmPurchase: '确认购买',
      confirmDeposit: '确认储值',
      reviewYourCart: '查看购物车',
      choosePaymentOption: '选择支付方式',
      paymentInformation: '付款信息',
      receipt: '收据',
      digitalEGiftCard: '数字电子礼品卡',
      subtotal: '小计',
      yourGiftCardDetails: '礼品卡详情',
      to: '至',
      from: '从',
      selectPaymentMethod: '选择支付方式',
      bonus: '奖励',
      points: '积分',
      depositDirectlyToAccount: '您的储值将直接存入与提供的电话号码关联的账户，从而更新余额。',
      receiptEmailSameAsRecipientEmail: '收据电子邮箱与收件人电子邮箱相同',
      personalizedMessage: '个性化消息',
      backToAllGiftDetails: '返回礼品卡详情',
      depositDetails: '储值详情',
      depositTo: '储值至:',
      addPayment: '添加支付方式'
    },

    confirmation: {
      thankyou: '感谢您购买礼品卡',
      thankyouWithName: '{0}，感谢您购买礼品卡',
      sentto: '您购买的{0}礼品卡已经发送至',
      depositSuccess: '感谢您的储值！',
      newBalance: '您的储值余额为 ',
      couponPurchase: '感谢您购买优惠券',
      useFundsDeposit: '使用储值余额',
      useFundsPurchase: '使用余额',
      makeAnotherDeposit: '再次储值',
      makeAnotherPurchase: '再次购买',
      giftCardValue: '礼品卡金额',
      weveSentTheGiftCardTo: '我们已将礼品卡发送至',
      itShouldArriveShortly: '它应该很快到达。',
      startAnOrder: '开始订单',
      purchaseAnotherCard: '购买另一个礼品卡',
      bonus: '奖励',
      depositSuccessful: '储值成功',
      addedTo: '已添加到',
      depositValue: '储值金额',
      deposited: '已储值',
      creditAddedToMembership: '积分已添加到您的会员账户 — 现在可用。',
    },

    deposit: {
      card1: {
        title: '会员储值信息',
        subtitle: '选择以下预设金额进行储值。',
        bonusTip: '更高的储值金额可享受额外奖励。',
        memberInformation: '会员信息',
        memberInformationSubtitle: '此储值将关联到此手机号码的会员账户。我们也会发送确认短信。',
      },
      card2: {
        title: '储值奖励',
        subtitle: '储值以下金额可获得额外奖励',
        bonusCoupons: '奖励兑换券',
        headers: ['信息', '储值金额', '奖励金额', '附赠积分', '奖励兑换券', 'One time bonus'],
        bonusInfo: `<span style="color:var(--primary-color, #16a34a);font-weight:600;">{0} 奖励</span> 储值 {1} 金额`,
        bonusInfoOrMore: `<span style="color:var(--primary-color, #16a34a);font-weight:600;">{0} 奖励</span> 储值 {1} 金额或更多`,
        bonusInfoRange: `<span style="color:var(--primary-color, #16a34a);font-weight:600;">{0} 奖励</span> 储值 {1} - {2} 金额`,
        bonusInfoPoints: `<span style="color:var(--primary-color, #16a34a);font-weight:600;">{0} 积分</span> 储值 {1} 金额`,
        bonusInfoPointsOrMore: `<span style="color:var(--primary-color, #16a34a);font-weight:600;">{0} 积分</span> 储值 {1} 金额或更多`,
        bonusInfoPointsRange: `<span style="color:var(--primary-color, #16a34a);font-weight:600;">{0} 积分</span> 储值 {1} - {2} 金额`,
      },
      preset: '储值金额',
      backToDepositDetail: '返回储值详情',
      backToHome: '返回主页',
      checkoutAndDeposit: '结账并储值',
    },  

    giftcard: {
      title: '礼品卡信息',
      defaultMessage: '希望你喜欢!',
      sub1: '您的礼品卡信息可以通过短信或邮件发送.',
      sub2: '请选择一种方式',
      chooseDesign: '选择完美的礼品卡',
      chooseDesignSub: '惊喜地给特别的人发送数字礼品卡，通过短信或邮件即时发送。完美适用于任何庆祝活动！',
      reChooseDesign: '想要尝试不同的风格？点击浏览更多设计',
      card2: {
        title: '礼品卡奖励',
        subtitle: '购买以下礼品卡可获得额外奖励',
        headers: ['信息', '购买金额', '奖励金额', '附赠积分', '奖励兑换卷', 'One time bonus'],

      },
      preset: '购买金额',
      backToAllGiftCards: '返回所有礼品卡',
      custom: '自定义',
      currentPromotions: '当前促销',
      message: '个性化消息',
      giftCardDesign: '礼品卡设计'
    },

    coupon: {
      title: '购买优惠券',

      addToCart: '加入购物车',
      remaining: '剩余',
      noneAvailable: '目前没有可购买的优惠券。'
    },

    migrate: {
      login: '请登录后进行账户迁移',
      selectOfTwo: '请从两个选项中选择一个',
      phoneHint: "请输入您的手机号码",
      realFruitLogin: "请登录以迁移您的账户",
      enterEmail: '请填写您账号对应电子邮箱地址',
      enterId: '请填写您的礼品卡号码',
      externalId: '礼品卡号码',
      giftCard: '礼品卡号码',
      externalIdHint: '此号码在您希望迁移的礼品卡上',
      giftCardHint: '您的礼品卡号码',
      email: '电子邮箱地址',
      emailHint: '此电子邮箱地址由您希望迁移的服务匹配',

      confirmDetails: '请核对您的信息',
      name: '姓名:',
      externalID: '礼品卡号码',
      pointsBalance: '积分额',
      balance: '余额',
      tier: '等级',

      migrated: '您的账号已成功完成迁移',
      migrateAgain: '迁移另一个账号'
    },

    errorReport: {
      main: '啊哦!',
      secondary: '出了点问题',
      invalidWechat: '请在微信客户端打开链接'
    },

    paymentDetails: {
      cardType: '信用卡或借记卡',
      wechat: '微信',
      cardNumber: '卡号',
      ready: '已准备好付款明细',
      accepted: '支付成功',
      inProgress: '购买申请受理中',
      cardDetailsError: '无法读取付款信息',
      cardDetailsMissing: '请输入您的银行卡信息',
      completePayment: '完成支付',
      addTip: '添加小费',
      paymentFailed: '支付失败，请检查您的信息后重试',

      subtotal: '小计',
      tip: '小费',
      total: '总计'
    },

    wechat: {
      error: '发生错误，请重试',
      mismatch: '银行卡与记录不匹配',
    },

    userAcount: {
      accountInfo: '账户信息',
      orderHistory: '历史记录',
      paymentMethods: '付款方式',
    },

    forms: {
      billing: {
        phone: '账单电话',
        sixDigitCode: '6位验证码',
        phoneHint: '输入您的账单电话',
        phoneError: '请输入一个电话号码',
        name: '账单姓名',
        nameHint: '持卡人姓名',
        email: '账单电子邮箱',
        emailHint: '请输入账单电子邮箱',
        emailError: '请输入有效电子邮箱',
        nameOnCard: '持卡人姓名',
      },

      deposit: {
        phone: '请输入需要储值的手机号码',
        phoneHint: '请输入一个电话号码',
        enterCustomAmount: '输入自定义金额',
      },

      giftcard: {
        phone: '收卡人电话号码',
        recipientMobilePhone: '收件人手机号码',
        phoneHint: '您想要收到礼品卡的电话',
        phoneError: '请输入一个电话号码',
        email: '收卡人电子邮箱',
        recipientEmail: '收件人电子邮箱',
        emailHint: '您想要收到礼品卡的邮箱',
        emailError: '请输入一个有效邮箱',
        name: '您的姓名',
        nameHint: '这将会显示在给收件人的信息里',
        message: '消息（可选）',
        messageHint: '这是与您的礼品卡一起发送的个性化消息',
        whoAreYouGiftingTo: '您要送给谁？',
        personalNote: '个性化备注',
        termsAndConditions: '条款和条件',
        checkOutAndSendGift: '结账并发送礼品卡',
        custom: '自定义',
        enterCustomAmount: '输入自定义金额',
        giftAmount: '礼品卡金额',
        senderName: '发件人姓名（可选）',
        recipientName: '收件人姓名',
        recipientNameHint: '您要赠送礼品卡的人的姓名',
        recipientNameError: '请输入收件人姓名',
        selectDeliveryMethod: '请选择配送方式',
        selectOrEnterAmount: '选择或输入礼品卡金额，整数金额在 {0} - {1} 之间',
        selectAnAmount: '选择一个金额',
        enterCustomDollarAmount: '输入自定义美元金额',
      },

      coupon: {
        phone: '请输入需要储值的请输入需要储值的手机号码',
        phoneHint: '输入您的账户电话号码',
        couponsError: '请选择一张优惠券'
      },

      emptyError: '请输入一个名字',
      amountPrompt: '请输入金额',
      cardPrompt: '请输入卡号',
      amountMax: '金额不能超过{0}',
      amountMin: '金额不能少于{0}',

      country: '信用卡所属国家',
      otherPostalCode: '邮编',
      checkout: {
        selectCountry: '请选择国家',
        enterPostalCode: '请输入邮编',
        fillMissingFields: '请填写缺失的字段'
      }
    },

    dialog: {
      recipient: '收卡人',
      mobile: '手机号',
      amount: '金额',
      message: '{0}送给您了一张礼品卡!'
    },
    presetRow: {
      title: '储值金额',
    },

    lottery: {
      loginTitle: '登录赢礼券',
      noCoupons: '无可用礼券',
      title: '玩转盘赢礼券',
      spin: '开始',
      youWon: '恭喜中奖！',
      useCoupon: '使用礼券',
      spinAgain: '再来一次',
      goShopping: '主页',
      lossText: '手气欠佳，下次再试试'
    },

    login: {
      login: '登入',
      phoneNumber: '电话号码',
      verifyCode: '验证码',
    },
    hours: {
      twentyFourHours: '24小时营业',
      midNight: '午夜',
      mon: '周一',
      tues: '周二',
      wed: '周三',
      thurs: '周四',
      fri: '周五',
      sat: '周六',
      sun: '周日',
      monday: '星期一',
      tuesday: '星期二',
      wednesday: '星期三',
      thursday: '星期四',
      friday: '星期五',
      saturday: '星期六',
      sunday: '星期日',
    },

    header: {
      location: '门店地址',
      order: '点餐',
      reservation: '预约',
      lineup: '等候名单',
      giftcard: '礼品卡',
      coupons: '购买优惠券',
      deposit: '充值',
      login: '登入 / 注册',
    },
  }
}
